import { render } from "./physiotherapy_notes.vue?vue&type=template&id=b0d3c050&scoped=true"
import script from "./physiotherapy_notes.vue?vue&type=script&lang=js"
export * from "./physiotherapy_notes.vue?vue&type=script&lang=js"

import "./physiotherapy_notes.vue?vue&type=style&index=0&id=b0d3c050&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0d3c050"]])

export default __exports__